var _defs, _ellipse, _rect, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSigningTermsOfServices17855930(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.1;fill:#2A94F4;}\n\t.st1{fill:#009688;}\n\t.st2{fill:#F7F7F7;}\n\t.st3{fill:#F2F2F2;}\n\t.st4{fill:#0B4870;}\n\t.st5{fill:#DBA17B;}\n\t.st6{fill:#2A94F4;}\n\t.st7{fill:#FFE3CA;}\n\t.st8{fill:#0E538C;}\n\t.st9{fill:#D19574;}\n"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 900.3,
    cy: 983.4,
    rx: 597.3,
    ry: 96.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 445.4,
    className: "st1",
    width: 693.3,
    height: 945.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1254.2,983.4 560.9,983.4 560.9,165.5 663.4,38 1254.2,38 \t"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "663.4,38 663.4,165.5 560.9,165.5 \t"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 678.3,
    y: 255.4,
    className: "st1",
    width: 377,
    height: 14.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1074.7,
    y: 255.4,
    className: "st1",
    width: 62,
    height: 14.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 678.3,
    y: 420.7,
    className: "st1",
    width: 126.3,
    height: 14.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 819.4,
    y: 420.7,
    className: "st1",
    width: 317.4,
    height: 14.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 678.3,
    y: 338.1,
    className: "st1",
    width: 126.3,
    height: 14.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832.6,
    y: 338.1,
    className: "st1",
    width: 135.5,
    height: 14.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.5,
    y: 338.1,
    className: "st1",
    width: 155.2,
    height: 14.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 759.8,
    y: 586,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1896.521 1186.6846)",
    className: "st1",
    width: 377,
    height: 14.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.3,
    y: 586,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1418.7179 1186.6846)",
    className: "st1",
    width: 62,
    height: 14.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 759.8,
    y: 668.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1896.521 1351.981)",
    className: "st1",
    width: 377,
    height: 14.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.3,
    y: 668.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1418.7179 1351.981)",
    className: "st1",
    width: 62,
    height: 14.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1010.5,
    y: 503.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 2147.2393 1021.3882)",
    className: "st1",
    width: 126.3,
    height: 14.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 847.1,
    y: 503.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1829.5754 1021.3882)",
    className: "st1",
    width: 135.5,
    height: 14.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.3,
    y: 503.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1511.9116 1021.3882)",
    className: "st1",
    width: 155.2,
    height: 14.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M683.6,839.4l-5.3-10.6c0.2-0.1,14.1-7,29.9-16.4c-2.1-2.6-3.9-5.5-5.5-8.6c-13.4-26.1-2.5-39.1,2.8-43.4 c13-10.7,37.4-9.4,53.2,3c4.2,3.3,6.2,7.9,5.7,12.8c-0.7,6.5-5.3,17.4-36.4,37.8c8.2,4.8,17.4,6.3,25.2,6.6 c24.2,0.8,46.3-9.8,49.8-15.6l10.5-17.6l0.5,20.5c0.1,4.3,1.8,10.1,3.7,10.7c0.3,0.1,6.4,1.8,23.7-20.2l9.3,7.3 c-15.5,19.7-27.2,27.4-36.8,24.2c-5.1-1.7-8-6.1-9.7-10.4c-11.7,7.6-31.8,13.7-51.5,13.1c-14.2-0.5-26.3-4.5-35.7-11.6 C699.8,831.3,684.3,839,683.6,839.4z M728.1,764.9c-5.9,0-11.4,1.5-15.1,4.6c-8.9,7.3-3.6,21.2,0.3,28.8c1.5,2.9,3.2,5.5,5.1,7.7 c30.7-19.6,33.9-28.7,34.2-31.1c0.1-0.5,0.1-1.2-1.2-2.3C744.9,767.6,736.1,764.9,728.1,764.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1165,228.5c0,0-28.2-32.1-19.2-53.1c9-21,38-18,42-26c4-8,53.1-9.7,56.9,10.3c3.8,20,32.5,65.8-9.3,81.2 C1193.6,256.3,1165,228.5,1165,228.5z",
    style: {
      fill: "rgb(65, 65, 65)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1203.7,321.6c0,0,8.3,102-1.6,129.5c-9.9,27.5-42.9,130.1-42.9,130.1l-19.4-9.3c0,0,16-85.3,26-133.9 c10-48.7,17.2-128.8,30.8-159.5L1203.7,321.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1219.7,513.3c0,0-10.9,132.3-10.9,155.3s0,268.1,0,268.1h29c0,0,31-212.1,32-241.1 c1-29,26.3-151.1,26.3-151.1S1318.6,434,1219.7,513.3z",
    style: {
      fill: "rgb(61, 70, 78)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1292.8,528.3c0,0,10.4,152.4,16.4,178.9c6,26.5,94,229.5,94,229.5h28c0,0-50.3-203.5-62.3-226 s4.6-204.7,4.6-204.7L1292.8,528.3z",
    style: {
      fill: "rgb(61, 70, 78)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1225.9,251.7c0,0,112.4-90.4,157.1,307.8h-170.1c0,0,16.4-37.6,9.3-87.5 C1208.8,377.9,1163.7,258.8,1225.9,251.7z",
    style: {
      fill: "rgb(0, 150, 136)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1468.9,355.3 1488.5,383.4 1066.7,698.6 1027.1,641.7 \t\t\t\t",
    style: {
      fill: "rgb(52, 57, 61)"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1202.1,503.6"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1067.8,697.8l-42.6,29.7c-11.9,8.3-28.3,5.4-36.6-6.5l-9.6-13.8c-8.3-11.9-5.4-28.3,6.5-36.6l42.6-29.7 L1067.8,697.8z",
    style: {
      fill: "rgb(52, 57, 61)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M914.8,716.4l-53.5,80.1l41.5-28.9c2.1-4.4,6.1-11.4,13-16.2c10.7-7.5,21.5-10.5,24.1-6.8 c2.6,3.7-4,12.8-14.7,20.3c-6.9,4.8-14.8,6.2-19.7,6.6l-41.5,28.9l93.6-22.4c0,0,46.6-50.2,33.5-69.1 C978.1,690,914.8,716.4,914.8,716.4z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1281.9,322.4l47.4-22.7c0,0,61,96.8,68.7,138.2s-112.3,107.3-112.3,107.3l-7.5-7.3c0,0,69.8-80,88.4-95.4 L1281.9,322.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1278.2,537.9c0,0-3.6-2-13.6,0s-22,15.3-22,15.3s-6.8,4.5,18-1.3c0,0-26.7,21.8-36.7,29.3 c-10,7.5,28.3,17.5,61.8-36L1278.2,537.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1257.8,228.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1295.9,351.2l47.5-32.8c0,0-30-77-89.8-75.5C1243.5,243.2,1228.4,268.8,1295.9,351.2z",
    style: {
      fill: "rgb(0, 150, 136)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1173.4,367.8l41.8,7.3l-6.6-116.8c0,0-19.4,9.5-24,31.4C1179.8,311.8,1173.4,367.8,1173.4,367.8z",
    style: {
      fill: "rgb(0, 150, 136)"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1217.5,275.1c0,0,27.3-4.7,24.3-20.7l-17.4-36l-22.7,13.7L1217.5,275.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1158.3,202.8c0.9,32.4,29.5,58.2,49.1,55.8c26.8-3.3,33.8-25.2,32.2-39.3c0,0,5.7-7.1,5.1-16.9 c-0.9-14.5-10.1-13.3-10.1-4.3c0,15.2-2.6-0.7-4.6-12.5s-12.8,26.1-31.7,21.2C1159.3,196.9,1157.4,170.5,1158.3,202.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1208.9,936.7c0,0-2.8,11.4-15,13.3c-20.2,3.2-40.7,4.6-43.3,17.4c-2.7,12.8,0,10,0,10h63.4c0,0,10-7,18,0 h15.3c0,0-3.3-25.1-4-29.1c-0.7-4.1-5.3-11.6-5.3-11.6H1208.9z",
    style: {
      fill: "rgb(33, 33, 33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1402.6,936.7c0,0,5,9.3-15,13.3c-20,4.1-40.7,4.6-43.3,17.4c-2.7,12.8,0,10,0,10h63.4c0,0,10-7,18,0h15.3 c0,0-3.3-25.1-4-29.1c-0.7-4.1-5.3-11.6-5.3-11.6H1402.6z",
    style: {
      fill: "rgb(33, 33, 33)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigningTermsOfServices17855930);
export default __webpack_public_path__ + "static/media/signing-terms-of-services-1785593-0.1fcdfe4dc8408af3af107f39268ff81c.svg";
export { ForwardRef as ReactComponent };